import _object_spread from "@swc/helpers/src/_object_spread.mjs";
export var EnvironmentFromFile = {
    Fred: "FRED",
    IDontWantThisCar: "I_DONT_WANT_THIS_CAR",
    FomoExperimentId: "FOMO_EXPERIMENT_ID",
    RequestCallbackExperimentId: "REQUEST_CALLBACK_EXPERIMENT_ID",
    SSRTest: "SSR_DEV_TEST",
    HomepageHMC: "HOMEPAGE_HMC"
};
export var Env = _object_spread({}, EnvironmentFromFile);
